import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['evolution', 'leap', 'pragmatic', 'sg-digital', 'relax', 'blueprint'],
        'live-casino': ['evolution', 'ezugi', 'pragmatic'],
        virtuals: ['leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    complianceNew: true,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'],
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: true,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: false,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            'This site is operated by Playbook Gaming Ltd, trading as Playbook Engineering Ltd, (licence number {{licenceNumber}}) is licensed and regulated by the Gambling Commission. No.1 Poultry, London EC2R 8EJ.',
        licence_number: '50122',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/50122',
        cookies_url: 'https://bresbet.com/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: true,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-57ZGSSC',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'BresBet',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '5',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'ding',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'Bresbet Events',
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: true,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    usePaymentFormForUniverse: {
        type: 'multi-deposit',
        apiKey: 'T1QtNDQ4NzQ0OkItcDEtMC02OGQyODZkZS0wLTMwMmMwMjE0NTAxZThlMTdkOGMyNmY0YmVlN2E5YTFmNWUyZmM1MDQ1MWYxNjMzODAyMTQ0OWFiMjIyMDZjY2EyNGU5YjQzZGJjNTQ1ZDVlMjE4YWM5ODA3ODlk',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1003458554',
            EUR: '', // TODO - add this value when ready: https://portals.paysafe.com/portal/developer/webhooks
        },
        openBanking: null,
    },
    userTitleOptional: false,

    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        BackofficeReports: 'BackOfficeReports-BresBet/DB-Casino',
        CasinoDashboard: 'CasinoDashboard-BresBet/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-BresBet/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-BresBet/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-Bresbet/DailyKPI',
        RacecourseDashboard: 'Racecourse-BresBet/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-BresBet/TransactionsMainDashboard',
        AccountBalances: 'AccountBalances-BresBet/AccountBalances',
        Conversions: 'ConversionsDashboard-BresBet/Conversions',
        RollingNetDeposits: 'RollingNetDeposits-BresBet/RollingNetDeposits',
        BonusEngine: 'BonusEngine-BresBet/CampaignLevel',
        PlatformOverview: 'Overview-Bresbet/Overview',
        SRGCompliance: 'SRGComplianceDashboard-Bresbet/DBAverageStakes',

        // TradingOverview: 'Trading-BresBet/Overview',
        // MarketingOverview: 'Marketing-BresBet/Overview',
        // PaymentsOverview: 'Payments-BresBet/Overview',
    },
};
